import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheetGuide from "../pages/blog/KakobuySpreadsheetGuide";
import KakobuyVsSuperbuy from "../pages/blog/KakobuyVsSuperbuy";
import SneakersSpreadsheet2026 from "../pages/blog/SneakersSpreadsheet2026";
import ShippingPolska from "../pages/blog/ShippingPolska";
import Bezpieczenstwo from "../pages/blog/Bezpieczenstwo";
import JakZaczac from "../pages/blog/JakZaczac";
import KakobuyVsPandabuy from "../pages/blog/KakobuyVsPandabuy";
import StreetwearSpreadsheet from "../pages/blog/StreetwearSpreadsheet";
import AkcesoriaSpreadsheet from "../pages/blog/AkcesoriaSpreadsheet";
import CenyPorownanie from "../pages/blog/CenyPorownanie";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-polska-guide-2026/",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/blog/kakobuy-vs-superbuy/",
    element: <KakobuyVsSuperbuy />,
  },
  {
    path: "/blog/kakobuy-sneakers-spreadsheet-2026/",
    element: <SneakersSpreadsheet2026 />,
  },
  {
    path: "/blog/kakobuy-shipping-polska/",
    element: <ShippingPolska />,
  },
  {
    path: "/blog/kakobuy-bezpieczenstwo/",
    element: <Bezpieczenstwo />,
  },
  {
    path: "/blog/kakobuy-jak-zaczac/",
    element: <JakZaczac />,
  },
  {
    path: "/blog/kakobuy-vs-pandabuy/",
    element: <KakobuyVsPandabuy />,
  },
  {
    path: "/blog/kakobuy-streetwear-spreadsheet/",
    element: <StreetwearSpreadsheet />,
  },
  {
    path: "/blog/kakobuy-akcesoria-spreadsheet/",
    element: <AkcesoriaSpreadsheet />,
  },
  {
    path: "/blog/kakobuy-ceny-porownanie/",
    element: <CenyPorownanie />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;